module.exports = __webpack_public_path__ + "static/media/adeeba.976207fc.jpg";